import { RefObject } from "react";

export function Img100 (props: {
    src : string,
    id ?: string,
    className ?: string
}) {
    const id = props.id !== undefined ? props.id : '';
    const className = props.className !== undefined ? props.className : '';
    return <img id={id} src={props.src} className={className + " width-100p"} />;
}